export enum MarketplacePageRoute {
    MAIN_PAGE = "/",
    SEARCH_PAGE = "/search",
    DETAIL = "/product/:productID",
    SUPPLIER_DETAIL = "/supplier/:companyID/branch/:branchID",
    CART = "/cart",
    UPDATE_QUOTATION = "/:quotationType/erfx/:erfxNo/type/:erfxType"
  }

  